// extracted by css-extract-rspack-plugin
export default {"settingsContainer":"zZvPsiplEOAOZU9b__settingsContainer___","content":"rZZqwLh0EgEK21xl__content___"};